import React from "react"

const Item3 = () => {
  return (
    <ul className="ml-16">
      <li><p style={{marginBottom: "12px"}} className="regular-parraf">El porcentaje de aceptación REAL que tiene nuestro curso es del 80%, a comparación de otros cursos que te ofrecen un mayor porcentaje de alumnos aceptados, pero solo es Ficticio.</p></li>
      <li><p className="regular-parraf">Observa las opiniones o pregunta a alguien que ya fue alumno de Plataforma ENARM, quien mejor que ellos para darte una recomendación sincera.</p></li>
    </ul>
  )
}

export default Item3;